export default __webpack_public_path__ + "static/media/Coin.6a1fefce.svg";